import { render, staticRenderFns } from "./TqCalendarBig.vue?vue&type=template&id=59e647a6&scoped=true&"
import script from "./TqCalendarBig.vue?vue&type=script&lang=js&"
export * from "./TqCalendarBig.vue?vue&type=script&lang=js&"
import style0 from "./TqCalendarBig.vue?vue&type=style&index=0&id=59e647a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e647a6",
  null
  
)

export default component.exports